import React, { useEffect, useState } from "react";
import "./MemberRegistration.css";
import StepperNavigation from "../../Components/StepperNavigation.tsx/StepperNavigation";
import MemberDetails from "../MemberDetails/MemberDetails";
import KYCDetails from "../KYCDetails/KYCDetails";
import Payment from "../PaymentDetails/Payment";
import CreatePassword from "../CreatePassword/CreatePassword";
import { getMemberRegistrationStatusByMemberId } from "../../Helpers/APIEndPoints/EndPoints";
import { APICall } from "../../Helpers/Network/APICalls";
import { ApplicationStatus } from "../../Helpers/Enums/ApplicationStatus";
import { useLocation } from "react-router-dom";
import {
  DeleteMemberIdFromLocalStorage,
  GetDecryptedMemberIdFromLocalStorage,
  SetEncryptedMemberIdToLocalStorage,
} from "../../Helpers/CommonFunctions/EncryptedMemberIdFunction";
import { useSelector } from "react-redux";
import { MemberRegistrationUserType } from "../../Helpers/Enums/MemberRegistrationUserType";
import notify, { ToastType } from "../../Helpers/ToastNotification";
import { decryptV2 } from "../../Helpers/Cryptography/CryptoV2";

const MemberRegistration = (props) => {
  const { state, search } = useLocation();
  const [activeStep, setActiveStep] = useState(0);
  const [isResetClicked, setIsResetClicked] = useState(false);
  const [isNextClicked, setIsNextClicked] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);
  const [stepsststatus, setStepStatus] = useState([false, false, false, false]);
  const memberid = GetDecryptedMemberIdFromLocalStorage() || state?.MemberId || "";
  const [statusData, setStatusData] = useState(null);
  const userTypeId: MemberRegistrationUserType = useSelector((state: any) => state?.MemberRegistrationReducer?.userTypeId);

  const [steps, setSteps] = useState([
    {
      label: "Member Details",
      completed: false,
      index: 0,
      isEnable: true,
    },
    {
      label: "KYC Details",
      completed: false,
      index: 1,
      isEnable: false,
    },
    {
      label: "Payment",
      completed: false,
      index: 2,
      isEnable: false,
    },
    {
      label: userTypeId === MemberRegistrationUserType.Officers ? "Account Setup" : "Setup Password",
      completed: false,
      index: 3,
      isEnable: false,
    },
  ]);
  //const {handleStepNext } = props;
  // useEffect(() => {
  //   if (isResetClicked && steps[stepIndex].isEnable && stepIndex == 1) {
  //     NextStep();
  //     setIsResetClicked(false);
  //   } newbuild
  // }, [isResetClicked, stepIndex, steps[stepIndex].isEnable]);
  useEffect(() => {
    // ActiveTab();
  }, [statusData]);

  useEffect(() => {
    if (userTypeId) {
      let newSteps = [...steps];
      switch (userTypeId) {
        case MemberRegistrationUserType.Officers:
          newSteps[3].label = "Account Setup";
          break;
        case MemberRegistrationUserType.Staff:
          newSteps[3].label = "Setup Password";
          break;
      }
      setSteps(newSteps);
    }
  }, [userTypeId]);

  useEffect(() => {
    if (memberid && memberid != null) {
      getMemberIdStatusDetails(memberid);
    }
  }, [memberid]);

  useEffect(() => {
    try {
      if (search) {
        const params = new URLSearchParams(search);
        if (params.has("error")) {
          const error = params.get("error");
          const errorDecoded = decodeURI(error);
          const errorDecrypted = decryptV2(errorDecoded);
          const errorArr = errorDecrypted.split("||");
          const errorStr = errorArr?.[0];
          const errorMemberId = errorArr?.[1];

          if (errorMemberId && errorMemberId !== "-1") {
            SetEncryptedMemberIdToLocalStorage(errorMemberId);
            getMemberIdStatusDetails(errorMemberId);
          } else if (errorStr === "USER_NOT_REGISTERED") {
            DeleteMemberIdFromLocalStorage();
            notify(ToastType.Error, "It seems you are not registered. \nPlease register here first.");
          }
        }
      }
    } catch (err) {}
  }, [search]);

  const enabledStep = (stepIds) => {
    if (stepIds) {
      let tempData = steps.map((st) => {
        if (stepIds.includes(st.index)) {
          return { ...st, isEnable: true };
        } else {
          return { ...st, isEnable: false };
        }
      });
      setSteps(tempData);
      setIsResetClicked(true);
    }
  };
  const ActiveTab = () => {
    if (
      (statusData?.IsMemberEmployementDetail === true &&
        statusData?.IsMemberNomineeDetail === true &&
        statusData?.IsMemberPersonalDetail === true &&
        statusData?.IsMemberWitnessDetail === true) ||
      statusData?.StatusName === "Rejected HR/HOD"
    ) {
      setActiveStep(1);

      let stepid = [0];
      // setStepStatus([true,false,false,false])
      if (stepid) {
        let tempData = steps.map((st) => {
          if (stepid.includes(st.index)) {
            return { ...st, completed: true };
          } else {
            return { ...st, completed: false };
          }
        });
        setSteps(tempData);
      }
    } else if (
      [
        ApplicationStatus.MemberRegistrationModule_PendingWithInternalTeam,
        ApplicationStatus.MemberRegistrationModule_RejectedByInternalTeam,
        ApplicationStatus.MemberRegistrationModule_PendingWithMemberForPaymentDetails,
        ApplicationStatus.MemberRegistrationModule_PendingWithEnrollmentCommittee,
        ApplicationStatus.MemberRegistrationModule_MemberRequestRejected,
      ].includes(statusData?.StatusId)
    ) {
      setActiveStep(2);
      let stepid = [0, 1];
      if (stepid) {
        let tempData = steps.map((st) => {
          if (stepid.includes(st.index)) {
            return { ...st, completed: true };
          } else {
            return { ...st, completed: false };
          }
        });
        setSteps(tempData);
      }
    } else if (
      [ApplicationStatus.MemberRegistrationModule_MemberRequestApproved, ApplicationStatus.MemberRegistrationModule_MemberIDCreationCompleted].includes(
        statusData?.StatusId
      )
    ) {
      setActiveStep(3);
      setStepStatus([true, true, true, false]);
      let stepid = [0, 1, 2];
      if (stepid) {
        let tempData = steps.map((st) => {
          if (stepid.includes(st.index)) {
            return { ...st, completed: true };
          } else {
            return { ...st, completed: false };
          }
        });
        setSteps(tempData);
      }
    } else {
      setActiveStep(0);
      setStepStatus([false, false, false, false]);
      let stepid = [];
      if (stepid) {
        let tempData = steps.map((st) => {
          if (stepid.includes(st.index)) {
            return { ...st, completed: true };
          } else {
            return { ...st, completed: false };
          }
        });
        setSteps(tempData);
      }
    }
  };
 
  const enablStepStatus = (id) => {
    if (id) {
      let tempData = stepsststatus.map((ss, index) => {
        if (index <= id) {
          return true;
        } else {
          return false;
        }
      });
      setStepStatus(tempData);
    }
  };

  const setCompletedSteps = (stepNo) => {
    let tempData = steps;
    if (stepNo == -1) {
      tempData = steps.map((ss) => {
        return { ...ss, completed: false };
      });
    } else {
      tempData = steps.map((ss) => {
        if (ss.index <= stepNo) {
          return { ...ss, completed: true };
        } else {
          return { ...ss, completed: false };
        }
      });
    }
    setSteps(tempData);
  };

  const getMemberIdStatusDetails = async (memberidParam) => {
    let url = `${getMemberRegistrationStatusByMemberId}`;
    let requestBody = { MemberId: memberidParam };

    const getData = await APICall(url, requestBody);
    setStatusData(getData?.Data);
    if (getData?.Data != null) {
      const statusId = getData.Data.StatusId;
      const IsMemberPersonalDetailsExists = getData.Data.IsMemberPersonalDetailsExists;
      const IsMemberWitnessDetailsExists = getData.Data.IsMemberWitnessDetailsExists;
      const IsMemberEmploymentDetailsExists = getData.Data.IsMemberEmploymentDetailsExists;
      const IsMemberNomineeDetailsExists = getData.Data.IsMemberNomineeDetailsExists;
      const IsAccountCreated = getData.Data.IsAccountCreated;

      if (statusId) {
        if (
          [
            ApplicationStatus.MemberRegistrationModule_Draft,
            ApplicationStatus.MemberRegistrationModule_PendingWithHRHOD,
            ApplicationStatus.MemberRegistrationModule_RejectedHRHOD,
          ].includes(statusId)
        ) {
          if (ApplicationStatus.MemberRegistrationModule_Draft) {
            if (IsMemberNomineeDetailsExists) {
              enabledStep([0, 1]);
              enablStepStatus(3);
              setActiveStep(1);
              setCompletedSteps(0);
            } else if (IsMemberEmploymentDetailsExists) {
              enabledStep([0]);
              enablStepStatus(2);
              setActiveStep(0);
              setCompletedSteps(-1);
            } else if (IsMemberWitnessDetailsExists) {
              enabledStep([0]);
              enablStepStatus(1);
              setActiveStep(0);
              setCompletedSteps(-1);
            } else {
              enabledStep([0]);
              enablStepStatus(0);
              setActiveStep(0);
              setCompletedSteps(-1);
            }
          } else {
            enabledStep([0, 1]);
            enablStepStatus(3);
            setActiveStep(1);
            setCompletedSteps(0);
          }
        } else if (
          [
            ApplicationStatus.MemberRegistrationModule_PendingWithInternalTeam,
            ApplicationStatus.MemberRegistrationModule_PendingWithMemberForPaymentDetails,
            ApplicationStatus.MemberRegistrationModule_PendingWithEnrollmentCommittee,
            ApplicationStatus.MemberRegistrationModule_RejectedByInternalTeam,
          ].includes(statusId)
        ) {
          if ([ApplicationStatus.MemberRegistrationModule_RejectedByInternalTeam].includes(statusId)) {
            enabledStep([0, 1, 2]);
            setActiveStep(2);
            setCompletedSteps(1);
          } else if ([ApplicationStatus.MemberRegistrationModule_PendingWithMemberForPaymentDetails].includes(statusId)) {
            if (isNextClicked) {
              enabledStep([0, 1, 2]);
              setActiveStep(2);
              setCompletedSteps(2);
              setIsNextClicked(false);
            } else {
              setIsNextClicked(true);
              enabledStep([0, 1]);
              setActiveStep(1);
              setCompletedSteps(1);
            }
          } else if ([ApplicationStatus.MemberRegistrationModule_PendingWithInternalTeam].includes(statusId)) {
            if (isNextClicked) {
              enabledStep([0, 1, 2, 3]);
              setActiveStep(2);
              setIsNextClicked(false);
            } else {
              setIsNextClicked(true);
              enabledStep([0, 1, 2]);
              setActiveStep(2);
            }
            setCompletedSteps(2);
          } else {
            enabledStep([0, 1, 2]);
            setActiveStep(2);
            setCompletedSteps(1);
          }
        } else if ([ApplicationStatus.MemberRegistrationModule_MemberRequestRejected].includes(statusId)) {
          if (isNextClicked) {
            enabledStep([0, 1, 2]);
            setActiveStep(2);
            setIsNextClicked(false);
          } else {
            setIsNextClicked(true);
            enabledStep([0, 1, 2]);
            setActiveStep(2);
          }
          setCompletedSteps(2);
        } else {
          if ([ApplicationStatus.MemberRegistrationModule_MemberRequestApproved].includes(statusId)) {
            if (isNextClicked || IsAccountCreated) {
              enabledStep([0, 1, 2, 3]);
              setActiveStep(3);
              setIsNextClicked(false);
            } else {
              setIsNextClicked(true);
              enabledStep([0, 1, 2]);
              setActiveStep(2);
            }
            setCompletedSteps(2);
          } else if ([ApplicationStatus.MemberRegistrationModule_MemberIDCreationCompleted].includes(statusId)) {
            enabledStep([0, 1, 2, 3]);
            setActiveStep(3);
            setIsNextClicked(false);
            setCompletedSteps(2);
          }
        }
      }
      return getData?.Data;
    }
  };

  const handleNextStep = async (stepIndex) => {
  
    //enabledStep(Array.from(Array(stepIndex).keys()));
    let statusDetails = await getMemberIdStatusDetails(memberid);
   
    if (steps[stepIndex].isEnable || steps[stepIndex].completed) {
      setActiveStep(stepIndex);
      setStepStatus((prev) => prev.map((d, index) => index < stepIndex && (d = true)));
    }
    return statusDetails;
  };

  // const NextStep = () => {
  //   console.log("active step");
  //   try {

  //     if (steps[stepIndex].isEnable) {
  //       setActiveStep(stepIndex);
  //       setStepStatus((prev) =>
  //         prev.map((d, index) => index < stepIndex && (d = true))
  //       );
  //     }
  //   } catch (error) {
  //     // Handle any errors from getMemberIdStatusDetails() here
  //     console.error("Error:", error);
  //   }
  // };

  // const handleNextStep = async (stepIndex) => {
  //   console.log("active step");
  //   //enabledStep(Array.from(Array(stepIndex).keys()));
  //   let statusDetails = await getMemberIdStatusDetails();
  //   console.log("statusData: ", statusDetails);
  //   if (steps[stepIndex].isEnable) {
  //     setActiveStep(stepIndex);
  //     setStepStatus((prev) =>
  //       prev.map((d, index) => index < stepIndex && (d = true))
  //     );
  //   }
  //   return statusDetails
  // };
  // console.log(activeStep)
  const selectPrevious = (stepIndex: any) => {
    setActiveStep(stepIndex);
    setStepStatus((prev) => prev.map((d, index) => index < activeStep && (d = true)));

    // setTabsStatus((prevStatus)=> prevStatus.map((d,i)=>i <= index ? d=false : d=true))
  };

  return (
    <div className="stepper_style" style={{ width: "100%", paddingTop: 20 }}>
      <StepperNavigation
        steps={steps}
        activeStep={activeStep}
        directStep={async (e) => await handleNextStep(e)}
        navigationBox={{
          0: <MemberDetails next={() => handleNextStep(1)} statusData={statusData} />,
          1: <KYCDetails previous={() => selectPrevious(0)} next={async () => await handleNextStep(2)} statusData={statusData} />,
          2: <Payment previous={() => selectPrevious(1)} next={async () => await handleNextStep(3)} statusData={statusData} />,
          3: <CreatePassword previous={() => selectPrevious(2)} statusData={statusData} />,
        }}
      />
    </div>
  );
};

export default MemberRegistration;
